/**
 * 將 ISO UTC 時間戳轉換為指定 IANA 時區的 "YYYY-MM-DD HH:mm:ss" 格式。
 * 未提供時區時，回退使用瀏覽器時區。
 */
export const formatTimestamp = (
  isoString: string | undefined | null,
  timezone?: string,
): string => {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "";
  const tz = timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const parts = new Intl.DateTimeFormat("sv-SE", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).format(date);
  return parts;
};

/**
 * Get trends for the last 7 days based on timestamp.
 *
 * @param items List of items with a timestamp property (ISO string)
 * @returns Array of { label: 'Day', value: count } for the last 7 days
 */
export const getLast7DaysTrends = <T extends { timestamp: string }>(
  items: T[] = [],
): { label: string; value: number }[] => {
  const trends = [];
  const today = new Date();

  for (let i = 6; i >= 0; i -= 1) {
    const d = new Date();
    d.setDate(today.getDate() - i);
    const dayStr = d.toLocaleDateString("en-US", { weekday: "short" }); // Mon, Tue...
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const dateStr = `${yyyy}-${mm}-${day}`; // YYYY-MM-DD in local timezone

    // Count items for this day
    // timestamp might be fuller ISO, so startswith is safe for date part
    const count = items.filter((r) => r.timestamp && r.timestamp.startsWith(dateStr)).length;

    trends.push({ label: dayStr, value: count });
  }
  return trends;
};
